<template>
  <scoped>
    <button
      :title="title"
      :class="switchClass()"
      :disabled="readOnly"
      @click="switchValue()"
    >
      {{ title }}
    </button>
  </scoped>
</template>

<script setup lang="ts">
  const props = defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    falsifiable: {
      default: true,
      required: false,
      type: Boolean
    },
    nullable: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  })

  const value = defineModel("value", {
    default: null,
    required: true,
    type: Boolean
  })
  
  function switchValue() {
    if (!props.falsifiable) {
      switch (value.value) {
        case true:
          value.value = null
          return
        default:
          value.value = true
          return
      }
    }
    if (!props.nullable) {
      switch (value.value) {
        case true:
          value.value = false
          return
        case false:
          value.value = true
          return
        default:
          value.value = true
          return
      }
    }
    switch (value.value) {
      case true:
        value.value = false
        return
      case false:
        value.value = null
        return
      default:
        value.value = true
        return
    }
  }
  
  function switchClass(): string {
    if (!props.falsifiable) {
      switch (value.value) {
        case true:
          return "true"
        default:
          return null
      }
    }
    if (!props.nullable) {
      switch (value.value) {
        case true:
          return "true"
        default:
          return "false"
      }
    }
  
    switch (value.value) {
      case false:
        return "false"
      case true:
        return "true"
      default:
        return null
    }
  }
</script>

<style scoped>
  button {
    background-color: var(--theme-color-primary);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    color: var(--color-white);
    cursor: pointer;
    margin: 0.5em;
    padding: 0.5em;
  
    &:before {
      background-color: var(--color-white);
      border-radius: var(--border-radius-small);
      content: "-";
      display: inline-block;
      margin-right: 0.5em;
      width: 1.5em;
    }
  
    &:focus, &:hover {
      background-color: var(--color-grey);
      border-color: var(--color-grey);
    }
  
    &:disabled {
      cursor: default;
  
      &:focus, &:hover {
        background-color: var(--theme-color-primary);
        border-color: var(--theme-color-primary);
      }
    }
  
    &.false:before {
      color: var(--color-red);
      content: "\2716";
    }
  
    &.true:before {
      color: var(--color-green);
      content: "\2714";
    }
  }
</style>
